<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
     <base-material-dialog
        title='客户绑定微信'
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='330'
      >
      <template v-slot:content>
          <v-card class="px-5" elevation="0">
            <v-row>
              <v-img max-height="330"
                max-width="300"
                :src="url"
              ></v-img>
            </v-row>
            <v-row class="align-center justify-center font-weight-light">扫描二维码即可绑定</v-row>
            <v-row class="align-center justify-center size-17 mb-3">{{item.data.name}}</v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
      <v-overlay :value="loading" absolute>
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </base-material-dialog>
  </v-container>
</template>

<script>

  import { getBindQrCode } from '@/api/customer/index.js'

  export default {
    name: 'CustomerCode',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        url: ''
      }
    },
    methods: {
      getBindQrCode () {
        this.loading = true
        getBindQrCode(this.item.data.id).then(res => {
          if (res.status === 200) {
            this.url = res.data
          }
          this.loading = false
        })
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          this.getBindQrCode()
        }
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
